// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"cce964bb","241":"b8242fce","264":"724cd933","403":"1ca485a3","514":"92e50042","653":"866feca9","720":"e422ff3e","941":"c12d31d9"}[chunkId] + ".css";
};